const styles = theme => ({
  container: {
    display: 'flex',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(2),
    },
  },
  title: {
    marginBottom: theme.spacing(2),
  },
  radioGroup: {
    marginBottom: theme.spacing(1),
    '& > .MuiFormControlLabel-root': {
      flex: '1',
    },
  },
  titleSectionRoot: {
    display: 'flex',
    alignItems: 'center',
    margin: theme.spacing(2, 0),
  },
  titleSectionIcon: {
    fontSize: '2.4rem',
    marginRight: theme.spacing(1) / 2,
  },
  titleSectionText: {
    fontSize: '1.2rem',
  },
  contractorContainer: {
    display: 'flex',
    alignItems: 'flex-start',
  },
  image: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'block',
      width: '40%',
    },
  },
  cartItem: {
    marginBottom: theme.spacing(2),
  },
  summary: {
    display: 'flex',
    flexDirection: 'column-reverse',
    alignItems: 'center',
    padding: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
  },
  textSummary: {
    fontWeight: theme.typography.fontWeightMedium,
    opacity: 0.8,
  },
  priceBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    justifyContent: 'center',
  },
  price: {
    ...theme.typography.h1,
    color: theme.palette.primary.main,
    fontWeight: theme.typography.fontWeightBold,
  },
  pricePrefix: {
    color: 'inherit',
    fontWeight: 'inherit',
    fontSize: '1.3rem',
    marginRight: theme.spacing(1),
  },
})

export default styles
